module.exports = __webpack_public_path__ + "static/media/tianying10.b92d2908.png";